import { ViewpointBuilderFooter } from 'viewpointBuilder/components/ViewpointBuilderFooter';
import { ComponentSearchViewState } from 'viewpointBuilder/selectContextTab/types';
import { ComponentsSearchCommands } from 'viewpointBuilder/selectContextTab/commands';
import { PrimaryButtonConfig } from 'viewpointBuilder/openViewpointBuilder/getPrimaryButtonConfig';
import { ContextConfig } from 'viewpointBuilder/openViewpointBuilder/getContextConfig';
import { SelectContextTabSearch } from './SelectContextTabSearch';
import { ComponentSearchResults } from './ComponentSearchResults';
import { Island, ModalBodyLayout } from '@ardoq/page-layout';
import { FlexBox } from '@ardoq/layout';
import type { I18nLocale } from '@ardoq/i18n';

type SelectContextTabContentProps = {
  state: ComponentSearchViewState;
  commands: ComponentsSearchCommands;
  closeViewpointBuilder: () => void;
  primaryButtonConfig: PrimaryButtonConfig;
  contextConfig: ContextConfig;
  viewpointName: string | null;
  i18nLocale: I18nLocale;
  namespace: string;
};

export const SelectContextTabContent = ({
  state,
  commands,
  closeViewpointBuilder,
  primaryButtonConfig,
  contextConfig,
  viewpointName,
  i18nLocale,
  namespace,
}: SelectContextTabContentProps) => {
  return (
    <ModalBodyLayout
      footerContent={
        <ViewpointBuilderFooter
          closeViewpointBuilder={closeViewpointBuilder}
          primaryButtonConfig={primaryButtonConfig}
          i18nLocale={i18nLocale}
        />
      }
    >
      <SelectContextTabSearch
        viewpointName={viewpointName || ''}
        state={state}
        contextConfig={contextConfig}
        commands={commands}
        i18nLocale={i18nLocale}
        namespace={namespace}
      />
      <FlexBox flex={1}>
        <Island
          fullHeight
          preventScroll
          bodySpacing="none"
          maxWidth={contextConfig.isNavigationPanelHidden ? '100%' : undefined}
        >
          <ComponentSearchResults
            state={state}
            commands={commands}
            i18nLocale={i18nLocale}
          />
        </Island>
      </FlexBox>
    </ModalBodyLayout>
  );
};
